module.exports = __webpack_public_path__ + "media/tip.bdeb5250.mp3";